import axios from '@/api/axios';
import Vapi from 'vuex-rest-api';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getCalendarEvents',
    path: ({ catalogId }) => `/calendar/${catalogId}/events`,
  })
  .get({
    action: 'getCalendarEvent',
    path: ({ catalogId, eventId }) => `/calendar/${catalogId}/events/${eventId}`,
  })
  .delete({
    action: 'removeCalendarEvent',
    path: ({ catalogId, eventId, offerId }) => `/calendar/${catalogId}/events/${eventId}?offerId=${offerId}`,
  })
  .get({
    action: 'getCalendarRules',
    path: ({ catalogId }) => `/calendar/${catalogId}/rules`,
  })
  .post({
    action: 'addCalendarRule',
    path: ({ catalogId, offerId }) => `/calendar/${catalogId}/rules?offerId=${offerId}`,
  })
  .delete({
    action: 'removeCalendarRule',
    path: ({ catalogId, ruleId, offerId }) => `/calendar/${catalogId}/rules/${ruleId}?offerId=${offerId}`,
  })
  .getStore();

export default store;
